import React from 'react';
import ReportFrame from '../ReportFrame';

export default class OpsPBIDashboard extends React.Component {
  render() {
    return (
      <div className='contentwrapperiframe bg-white'>
        <iframe
          title='OpsPBIDashboard'
          src='https://app.powerbi.com/view?r=eyJrIjoiMGI2OTJiNjEtY2NhOC00NzNhLWJhMWUtMTk5YWYxZTVmZDFmIiwidCI6IjE0NWE1Yjg1LTkzYWEtNDg2OC1hZmEwLWFkZWRjOTA0ZWM3YSIsImMiOjF9'
          className='report-frame'
          id='opsPBIDashboard'
          name='opsPBIDashboard'
          frameborder='0'
          allowFullScreen='true'
        />
      </div>
    );
  }
}
